<template>
  <div class="flex">
    <svg
      v-for="starNumber in starNumbers"
      :key="starNumber"
      :width="starSize"
      :height="starSize"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        :class="[starColor(starNumber)]"
        d="M11.3281 2.46955C11.5767 1.84349 12.4233 1.84348 12.6719 2.46955L14.909 8.10377C15.0138 8.3677 15.2507 8.54803 15.5228 8.57088L21.3294 9.05852C21.9746 9.1127 22.2363 9.95618 21.7447 10.3973L17.3206 14.3671C17.1134 14.553 17.0229 14.8448 17.0862 15.1229L18.4378 21.0585C18.588 21.718 17.903 22.2393 17.3506 21.8859L12.3793 18.7051C12.1464 18.5561 11.8536 18.5561 11.6207 18.7051L6.64937 21.8859C6.09696 22.2393 5.41201 21.718 5.5622 21.0585L6.91382 15.1229C6.97714 14.8448 6.88663 14.553 6.67939 14.3671L2.25532 10.3973C1.76373 9.95618 2.02536 9.1127 2.67058 9.05852L8.47725 8.57088C8.74926 8.54803 8.98621 8.3677 9.091 8.10377L11.3281 2.46955Z"
      />
      <path
        :class="[starColor(starNumber - 0.5)]"
        d="M12 2C11.7262 2 11.4524 2.15652 11.3281 2.46955L9.091 8.10377C8.98621 8.3677 8.74926 8.54803 8.47725 8.57088L2.67058 9.05852C2.02536 9.1127 1.76373 9.95618 2.25532 10.3973L6.67939 14.3671C6.88663 14.553 6.97714 14.8448 6.91382 15.1229L5.5622 21.0585C5.41201 21.718 6.09696 22.2393 6.64937 21.8859L11.6207 18.7051C11.7371 18.6306 11.8686 18.5934 12 18.5934V2Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'RatingStars',
  props: {
    score: {
      type: Number,
      required: true,
    },
    size: {
      type: String,
      validator(size) {
        return ['xs', 'sm', 'default'].indexOf(size) !== -1;
      },
      default: 'default',
    },
  },
  computed: {
    // Must not be a literal like `in 5`: Vue then stops treating each <svg> as its own block, patches the
    // <path> classes as HTML when the score changes, throws, and leaves the old stars on screen.
    starNumbers() {
      return [1, 2, 3, 4, 5];
    },
    starSize() {
      return {
        default: 24,
        sm: 16,
        xs: 14,
      }[this.size];
    },
  },
  methods: {
    starColor(starNumber) {
      return this.score >= starNumber
        ? 'fill-green'
        : 'fill-grey-300';
    },
  },
};
</script>
